import { render, staticRenderFns } from "./add-lottery-pop.vue?vue&type=template&id=83ec4dd0&scoped=true&"
import script from "./add-lottery-pop.vue?vue&type=script&lang=js&"
export * from "./add-lottery-pop.vue?vue&type=script&lang=js&"
import style0 from "./add-lottery-pop.vue?vue&type=style&index=0&id=83ec4dd0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ec4dd0",
  null
  
)

export default component.exports